export default __webpack_public_path__ + "static/media/audio_41_botella_rota.fdbf51ae.mp3";